import Sidebar from '../utill/Sidebar'
import Header from "../utill/Header";
import Footer from "../utill/Footer";
import {Card, Form, Table} from "react-bootstrap";
import React, {ChangeEvent, Fragment, useContext, useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import axios from "axios";
import Url from "../utill/Url";
import {useSelector} from "react-redux";
import {reissue} from "../utill/UtilComponent";
import {Checkbox} from "@mui/material";
import styles from "../../css/Authority.module.css";
import {RootState} from "../../redux/store";

function AuthorityModify() {
    const url = useContext(Url)
    const navigate = useNavigate();
    const nowUser = useSelector((state: RootState) => state.user.value);
    const location = useLocation();
    const [authority, setAuthority] = useState([]);
    const [authorityName, setAuthorityName] = useState('');
    const [description, setDescription] = useState('');
    const [data, setData] = useState<Authority[]>([]);

    const authorityId = location.state?.id
    let userId = nowUser.id;
    const auth = useSelector((state: RootState) => state.loginAuth.value);

    useEffect(() => {
        document.title = 'Mcon 모니터링 시스템-권한 수정'
        if (auth.MENUAUTH?.SET0100?.readAuthorityYn !== "1" && auth.MENUAUTH?.SET0100?.writeAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.');
            navigate(auth.firstUrl);
        }
        else if (auth.MENUAUTH?.SET0100?.writeAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다')
            navigate('/AuthorityManagement')
        }
        const menuAuth = Object.values(auth.MENUAUTH)
        // let sortedMenuData = [...menuAuth].sort((a, b) => a.menuOrder - b.menuOrder);
        // const commonChanges = {
        //     readAuthorityYn: false,
        //     writeAuthorityYn: false,
        //     loginId: userId,
        // };
        // // const propertiesToDelete = ['menuLevel', 'menuName','menuOrder','menuUrl','upperMenuCode'];
        // const propertiesToDelete = ['menuOrder'];
        // setAuthority(sortedMenuData.map(obj => {
        //     const changedElement = {...obj, ...commonChanges};
        //     for (const propertyToDelete of propertiesToDelete) {
        //         delete changedElement[propertyToDelete];
        //     }
        //     return changedElement;
        // }))
        reissue(userId, url, navigate).then(() => {
            axios.get(url + 'authority/find', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: {
                    data: authorityId,
                    type:1
                }
            }).then((response) => {
                setAuthorityName(response.data.result.data[0].authorityName)
                setDescription(response.data.result.data[0].description)
            })
            axios.get(url + 'menuauthority/find', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: {
                    authorityId: authorityId,
                }
            }).then((response) => {
                setData(response.data.result.result.sort((a: { menuOrder: number; }, b: { menuOrder: number; }) => a.menuOrder - b.menuOrder).map((data: { readAuthorityYn: string; writeAuthorityYn: string; }) => {
                    return {
                        ...data,
                        loginId:userId,
                        readAuthorityYn: data.readAuthorityYn === "1",
                        writeAuthorityYn: data.writeAuthorityYn === "1"
                    }
                }))
            })
        });
    }, []);

    const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
        reissue(userId, url, navigate).then(() => {
            e.preventDefault();
            if (!authorityId || !authorityName) {
                alert('권한ID와 권한명은 필수 입력 항목입니다.');
                return;
            }
            const isAction = window.confirm('저장 하시겠습니까?');
            if (isAction) {
                try {
                    axios.put(url + 'authority/update', {
                        authorityId: authorityId,
                        authorityName: authorityName,
                        description: description,
                        loginId: userId,
                        menuAuthorityDtoList: data
                    }, {
                        headers: {
                            'Authorization': localStorage.getItem('Authorization')
                        }
                    }).then(() => {
                            alert('권한이 저장되었습니다.');
                            navigate('/AuthorityManagement');
                        }
                    )
                } catch (e) {
                    console.error(e);
                }
            }
        })
    };

    const handleModifyCancel = () => {
        const Cancel = window.confirm('취소하시겠습니까?');
        if (Cancel) {
            navigate('/AuthorityManagement');
        }
    }

    const handledelete = async (e: React.MouseEvent<HTMLButtonElement>) => {
        reissue(userId, url, navigate).then(() => {
            e.preventDefault();
            const Delete = window.confirm('삭제하시겠습니까?');
            if (Delete) {
                try {
                    axios.delete(url + `authority/delete/${authorityId}`, {
                        headers: {
                            'Authorization': localStorage.getItem('Authorization')
                        }
                    })
                        .then(res => {
                            if (res.data.code === 200){
                                alert('권한이 삭제 되었습니다.');
                                navigate('/AuthorityManagement')
                            }else if (res.data.code === 409){
                                alert(res.data.message)
                            }
                        })
                } catch (e) {
                    console.error(e);
                    alert('삭제 실패 하였습니다.');
                }
            }
        })
    }

    const handleNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        setAuthorityName(e.target.value);
    };

    const handleDescriptionChange = (e: ChangeEvent<HTMLInputElement>) => {
        setDescription(e.target.value);
    };

    const handleReadAuthorityYnChange = (menuCode: string, readAuthorityYn: boolean) => {
        setData(data.map(obj =>
            obj.menuCode === menuCode ? { ...obj, ['readAuthorityYn']: !readAuthorityYn } : obj
        ));
    }

    const handleWriteAuthorityYnChange = (menuCode: string,writeAuthorityYn: boolean) => {
        setData(data.map(obj =>
            obj.menuCode === menuCode ? {...obj, ['writeAuthorityYn']:!writeAuthorityYn} : obj
        ));
    }

    useEffect(() => {
        const targetObj = data.find(obj =>
            obj.menuCode === "SET0000"
        );

        if(targetObj) {
            const menuCodes = ["SET0100", "SET0200", "SET0300"];

            const hasAuthority = menuCodes.some(code => {
                const obj = data.find(obj => obj.menuCode === code);
                return obj && obj.readAuthorityYn;
            });
            targetObj.readAuthorityYn = hasAuthority;
        }
    }, [data]);

    useEffect(() => {
        const targetObj = data.find(obj =>
            obj.menuCode === "STAT0000"
        );

        if(targetObj) {
            const menuCodes = ["STAT0100", "STAT0200", "STAT0300"];

            const hasAuthority = menuCodes.some(code => {
                const obj = data.find(obj => obj.menuCode === code);
                return obj && obj.readAuthorityYn;
            });
            targetObj.readAuthorityYn = hasAuthority;
        }
    }, [data]);

    useEffect(() => {
        const targetObj = data.find(obj =>
            obj.menuCode === "HIST0000"
        );

        if(targetObj) {
            const menuCodes = ["HIST0100", "HIST0200", "HIST0300"];

            const hasAuthority = menuCodes.some(code => {
                const obj = data.find(obj => obj.menuCode === code);
                return obj && obj.readAuthorityYn;
            });
            targetObj.readAuthorityYn = hasAuthority;
        }
    }, [data]);


    return (
        <div id="wrapper">
            <Sidebar menuCode={"SET0100"}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <Header pageName='권한 수정'/>
                        <Card className="card shadow mb-4">
                            <Card.Body>
                                <Table bordered>
                                    <tbody>
                                    <tr>
                                        <td style={{width: '20%', verticalAlign:'middle'}} className={styles.tableHead}><p>권한ID</p>
                                        </td>
                                        <td style={{width: '80%', height:'42px', verticalAlign:'middle'}}><p>{authorityId}</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.tableHead}><p>권한명</p></td>
                                        <td><Form.Control type="text" placeholder="권한명을 적어주세요" name="authorityName"
                                                          value={authorityName} onChange={handleNameChange}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.tableHead}>
                                            <p>설명</p>
                                        </td>
                                        <td>
                                            <Form.Control  type="text"
                                                          placeholder="설명을 적어주세요" name="description"
                                                          value={description} onChange={handleDescriptionChange}/>
                                        </td>
                                    </tr>
                                    </tbody>
                                </Table>
                                <Table bordered className="text-center">
                                    <thead>
                                    <tr>
                                        <th colSpan={2} className={styles.tableHead}>메뉴 명</th>
                                        <th className={styles.tableHead}>읽기</th>
                                        <th className={styles.tableHead}>쓰기</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {data
                                        .filter((menu) => menu.menuLevel === 1)
                                        .map((menu) => (
                                            <Fragment key={menu.menuCode}>
                                                {menu.menuUrl ? (
                                                    <tr>
                                                        <td colSpan={2}>{menu.menuName}</td>
                                                        <td>
                                                            <Checkbox
                                                                checked={menu.readAuthorityYn}
                                                                onChange={() => handleReadAuthorityYnChange(menu.menuCode, menu.readAuthorityYn)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Checkbox
                                                                checked={menu.writeAuthorityYn}
                                                                onChange={() => handleWriteAuthorityYnChange(menu.menuCode, menu.writeAuthorityYn)}
                                                            />
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    <>
                                                        <tr>
                                                            <th colSpan={2} style={{verticalAlign: 'middle'}}
                                                                className={styles.tableHead}>{menu.menuName}</th>
                                                            <th colSpan={2} className={styles.tableHead}></th>
                                                        </tr>
                                                        {data
                                                            .filter((subMenu) => subMenu.upperMenuCode === menu.menuCode)
                                                            .map((subMenu) => (
                                                                <Fragment key={subMenu.menuCode}>
                                                                    <tr>
                                                                        <td className={styles.tableBody} colSpan={2}>{subMenu.menuName}</td>
                                                                        <td className={styles.tableBody}>
                                                                            <Checkbox
                                                                                checked={subMenu.readAuthorityYn}
                                                                                onChange={() => handleReadAuthorityYnChange(subMenu.menuCode, subMenu.readAuthorityYn)}
                                                                            />
                                                                        </td>
                                                                        <td className={styles.tableBody}>
                                                                            <Checkbox
                                                                                checked={subMenu.writeAuthorityYn}
                                                                                onChange={() => handleWriteAuthorityYnChange(subMenu.menuCode, subMenu.writeAuthorityYn)}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                </Fragment>
                                                            ))}
                                                    </>
                                                )}
                                            </Fragment>
                                        ))}
                                    </tbody>
                                </Table>
                                <div className="btn modify">
                                    <button className="btn btn-primary"
                                            onClick={handleSubmit} type="submit">저장
                                    </button>
                                    <button className="btn btn-danger" onClick={handledelete}>삭제
                                    </button>
                                    <button className="btn btn-secondary" onClick={handleModifyCancel}>취소
                                    </button>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    )
}

export default AuthorityModify;